import {
  Card,
  CardContent,
  Grid,
  Typography
} from "@material-ui/core";
import { Avatar, Box, Stack, Tooltip } from "@mui/material";
import CircularProgress from "@mui/material/CircularProgress";
import Tab from "@mui/material/Tab";
import Tabs from "@mui/material/Tabs";
import jwt_decode from "jwt-decode";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import customer_image from "../../assets/admin_dashboard_image/customer_image.svg";
import dealer_image from "../../assets/admin_dashboard_image/dealer_image.svg";
import DataTableLatest from "../../components/DataTable/DataTableLatest";
import {
  getAccountList,
  getAccountStatics,
} from "../../slices/DashboardPanel/DashboardPanelSlice";
import SimpleDialogDemo from "../Approvals/ImageDailogBox";
import CustomersIcon from "../Customer/CustomersIcon";
import DashboardTiles from "../DashBoard/DashboardTiles";
import DealerIcon from "../Dealer/DealerIcon";

const cardStyle = {
  height: "120px",
  backgroundColor: "#FFFFFF",
  boxShadow: "none",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  padding: "0 20px",
};

const cardheadingStyle = {
  color: "rgb(0 0 0 / 89%)",
  fontSize: "14px",
  overflow: "hidden",
  textOverflow: "ellipsis",
  whiteSpace: "nowrap",
};

const cardDataCountStyle = {
  color: "rgba(61, 73, 119, 1)",
  fontSize: "30px",
  fontWeight: "bold",
  display: "flex",
  alignItems: "center",
};

function TabPanel(props) {
  const { children, value, index, ...other } = props;
  return (
    <div {...other}>{value === index && <Box pt={2}>{children}</Box>}</div>
  );
}

function DashBoardData(props) {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const [value, setValue] = React.useState(0);
  const [totalRecords, setTotalRecords] = useState(1);
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(50);
  const [accountStatics, setAccountStatics] = useState({
    totalDealerAccounts: 0,
    totalDealerActiveAccounts: 0,
    totalDealerInActiveAccounts: 0,
    totalCustomerAccounts: 0,
    totalCustomerActiveAccounts: 0,
    totalCustomerInActiveAccounts: 0,
  });
  const [accountRows, setAccountRows] = useState([]);
  const [accountState, setAccountState] = useState({
    type: "PARTNER",
  });
  const [companyType, setCompanyType] = useState("");
  const [cascadeLimit, setCascadeLimit] = useState(1);
  const [paging, setPaging] = useState({
    pageNumber: 1,
    pageSize: 50,
  });
  const [loading, setLoading] = useState(true);
  const [accountStateDealer, setAccountStateDealer] = useState({
    type: "CUSTOMER",
  });


  const handleChange = (event, newValue) => {
    setPaging({
      pageNumber: 1,
      pageSize: 50,
    });
    setRowsPerPage(50)
    if (newValue === 0) {
      setAccountState({
        ...accountState,
        type: "PARTNER",
      });
      setCascadeLimit(1);
    } else {
      setAccountState({
        ...accountState,
        type: "CUSTOMER",
      });
      setCascadeLimit(2);
    }
    setValue(newValue);
  };

  const calculateInitialHeight = () => {
    return window.innerHeight - 135;
  };

  const [height, setHeight] = useState(calculateInitialHeight);
  const [initialWindowHeight, setInitialWindowHeight] = useState(
    window.innerHeight
  );
  useEffect(() => {
    const handleResize = () => {
      setHeight(calculateInitialHeight);
      setInitialWindowHeight(window.innerHeight);
    };
    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, [initialWindowHeight]);

  useEffect(() => {
    const decoded = jwt_decode(localStorage.getItem("VISJwtToken"));
    setCompanyType(decoded.companyType);
  }, [companyType]);

  useEffect(() => {
    loadAccountStatics();
  }, []);

  useEffect(() => {
    loadAccountList(cascadeLimit, paging, accountState);
  }, [value, paging]);

  const loadAccountStatics = () => {
    dispatch(getAccountStatics(cascadeLimit))
      .unwrap()
      .then((data) => {
        if (data.code === "MSGS4009" && data.data) {
          setLoading(false);
          setAccountStatics({
            totalDealerAccounts: data.data.totalDealerAccounts,
            totalDealerActiveAccounts: data.data.totalDealerActiveAccounts,
            totalDealerInActiveAccounts: data.data.totalDealerInActiveAccounts,
            totalCustomerAccounts: data.data.totalCustomerAccounts,
            totalCustomerActiveAccounts: data.data.totalCustomerActiveAccounts,
            totalCustomerInActiveAccounts:
              data.data.totalCustomerInActiveAccounts,
          });
        }
      });
  };

  const loadAccountList = () => {
    const decoded = jwt_decode(localStorage.getItem("VISJwtToken"));
    let payload;
    if (decoded.companyType === "PARTNER") {
      payload = {
        cascadeLimit: 2,
        accountDTO: accountStateDealer,
        page: paging,
      };
    } else {
      payload = {
        cascadeLimit: cascadeLimit,
        accountDTO: accountState,
        page: paging,
      };
    }

    dispatch(getAccountList(payload))
      .unwrap()
      .then((data) => {
        if (data.code === "MSGS4009" && data.data) {
          setAccountRows(data.data.companies);
          setTotalRecords(data.data.totalCount);
          setPage(data.data.currentPage);
          setTotalPages(data.data.totalPages);
        }
      });
  };

  const handlePage = (newPage, size) => {
    setPage(newPage);
    setRowsPerPage(size);
    setPaging({
      pageNumber: newPage,
      pageSize: size,
    });
  };
  const testBackGroundColors = [
    "#C7D4E7",
    "#F8EACD",
    "#DBE1D7",
    "#EBD3E1",
    "#E2DEED",
    "#EBD3D3",
    "#D7EEE8",
    "#D3F5D5",
    "#E5D9C3",
    "#D2C785",
    "#C6E0E3",
    "#E4D8EB",
    "#D0D1DC",
    "#CCE1D8",
    "#CBDAEC",
    "#F6FCE1",
    "#F6FCE1",
    "#DBD0CE",
    "#C3DFCF",
    "#E6D8E5",
    "#C3EBE1",
    "#C0E5F5",
    "#EBE3B1",
    "#F6CFCF",
    "#ECD4E9",
    "#D5F6CF",
    "#DAD9F5",
    "#F2E1CB",
  ];

  const textColors = [
    "#2D4568",
    "#6C5629",
    "#2F4B1C",
    "#491D37",
    "#20163B",
    "#572626",
    "#214C42",
    "#275E2B",
    "#7D6845",
    "#677820",
    "#29666D",
    "#4E2168",
    "#1E203A",
    "#194130",
    "#143F70",
    "#586E0C",
    "#392871",
    "#543935",
    "#395847",
    "#6D3969",
    "#085341",
    "#1E3C4A",
    "#3E380D",
    "#481515",
    "#381434",
    "#163610",
    "#13123E",
    "#30210E",
  ];

  const getAvatarColor = (name) => {
    const colors = [
      "#C7D4E7",
      "#F8EACD",
      "#DBE1D7",
      "#EBD3E1",
      "#E2DEED",
      "#EBD3D3",
      "#D7EEE8",
      "#D3F5D5",
      "#E5D9C3",
      "#D2C785",
      "#C6E0E3",
      "#E4D8EB",
      "#D0D1DC",
      "#CCE1D8",
      "#CBDAEC",
      "#F6FCE1",
      "#F6FCE1",
      "#DBD0CE",
      "#C3DFCF",
      "#E6D8E5",
      "#C3EBE1",
      "#C0E5F5",
      "#EBE3B1",
      "#F6CFCF",
      "#ECD4E9",
      "#D5F6CF",
      "#DAD9F5",
      "#F2E1CB",
    ];
    const index =
      name.split("").reduce((acc, char) => acc + char.charCodeAt(0), 0) %
      colors.length;
    return colors[index];
  };

  const ZoomHandaler = (params) => {
    const { name, imagePreSignedURL } = params.row;

    const getColorIndex = (name) => {
      const total = name
        .toUpperCase()
        .split("")
        .reduce((sum, char) => sum + char.charCodeAt(0), 0);
      return total % testBackGroundColors.length;
    };
    // Get initials
    const initials = `${name?.charAt(0) || ""}`;
    const bgColor = !imagePreSignedURL
      ? getAvatarColor(initials)
      : "transparent";
    const colorIndex = getColorIndex(initials);
    const textColor = imagePreSignedURL ? "inherit" : textColors[colorIndex];

    return (
      <SimpleDialogDemo
        button={
          <Avatar
            style={{
              cursor: "pointer",
              backgroundColor: bgColor,
              color: textColor,
            }}
            alt={name}
            src={imagePreSignedURL || undefined}
          >
            {!imagePreSignedURL && initials.toUpperCase()}
          </Avatar>
        }
        child={
          <Avatar
            style={{
              width: "300px",
              height: "300px",
              border: "1px solid #FFFF",
              fontSize: "100px",
              borderRadius: "50%",
              cursor: "pointer",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              backgroundColor: bgColor,
              color: textColor,
            }}
            alt={name}
            src={imagePreSignedURL || undefined}
          >
            {!imagePreSignedURL && initials.toUpperCase()}
          </Avatar>
        }
      />
    );
  };

  const columns = React.useMemo(() => [
    {
      field: "user.profile",
      headerName: "",
      sortable: false,
      width: 5,
      renderCell: (params) => ZoomHandaler(params),
    },
    {
      field: "companyName",
      headerName: t("CUSTDATABLE01"),
      flex: 1,
      minWidth: 150,
      valueGetter: (params) => params.row.name,
      renderCell: (params) => (
        <Tooltip title={`${params.value}`} placement="bottom-start">
          <span>{params.value}</span>
        </Tooltip>
      ),
    },
    {
      field: "email",
      headerName: t("CUSTDATABLE02"),
      flex: 1,
      minWidth: 150,
      valueGetter: (params) => params.row.email,
      renderCell: (params) => (
        <Tooltip title={`${params.row.email}`} placement="bottom-start">
          <span>{params.row.email}</span>
        </Tooltip>
      ),
    },
    {
      field: "mobile",
      headerName: t("CUSTDATABLE03"),
      type: "singleSelect",
      flex: 1,
      minWidth: 150,
      valueGetter: (params) => params.row.phone,
    },
    {
      field: "AdminName",
      headerName: t("CUSTDATABLE04"),
      flex: 1,
      minWidth: 150,
      valueGetter: (params) => params.row.adminName,
      renderCell: (params) => (
        <Tooltip title={`${params.value}`} placement="bottom-start">
          <span>{params.value}</span>
        </Tooltip>
      ),
    },
  ]);

  const cardData = [
    {
      key: "dealerCount",
      bgColor: "#0F5A9C",
      text: "DASHBOARDCARDSDEALERCOUNT",
      count: accountStatics.totalDealerAccounts,
      image: dealer_image,
      visibleFor: ["NONE"], // Only show for "NONE"
    },
    {
      key: "activeDealer",
      bgColor: "#36C96D",
      text: "DASHBOARDCARDSACTIVEDEALER",
      count: accountStatics.totalDealerActiveAccounts,
      image: dealer_image,
      visibleFor: ["NONE"],
    },
    {
      key: "inactiveDealer",
      bgColor: "#F84F4F",
      text: "DASHBOAEDCARDSINACTIVEDEALER",
      count: accountStatics.totalDealerInActiveAccounts,
      image: dealer_image,
      visibleFor: ["NONE"],
    },
    {
      key: "customerCount",
      bgColor: "#2499FF",
      text: "DASHBOARDCARDSCUSTOMERCOUNT",
      count: accountStatics.totalCustomerAccounts,
      image: customer_image,
      visibleFor: ["PARTNER", "NONE"], // Show for both "PARTNER" and "NONE"
    },
    {
      key: "activeCustomer",
      bgColor: "#16BDBF",
      text: "DASHBOARDCARDSACTIVECUSTOMER",
      count: accountStatics.totalCustomerActiveAccounts,
      image: customer_image,
      visibleFor: ["PARTNER", "NONE"],
    },
    {
      key: "inactiveCustomer",
      bgColor: "#FE696C",
      text: "DASHBOARDCARDSINACTIVECUSTOMER",
      count: accountStatics.totalCustomerInActiveAccounts,
      image: customer_image,
      visibleFor: ["PARTNER", "NONE"],
    },
  ];
  return (
    <>
      <Grid container xs={12}>
        <Grid container spacing={2} style={{ paddingTop: "10px" }}>
          {cardData.map(
            (card) =>
              card.visibleFor.includes(companyType) && (
                <DashboardTiles minWidth={companyType === "PARTNER" ? "33.2%" : ""} key={card.key}>
                  <Card className="card mb-4" style={cardStyle}>
                    <CardContent className="p-0" style={{ width: "100%" }}>
                      <Grid xs={12}>
                        <Tooltip title={t(card.text)}>
                          <Typography
                            gutterBottom
                            variant="h6"
                            component="h2"
                            style={cardheadingStyle}
                          >
                            {t(card.text)}
                          </Typography>
                        </Tooltip>
                      </Grid>
                      <Stack
                        direction="row"
                        style={{
                          display: "flex",
                          justifyContent: "space-between",
                        }}
                      >
                        <Box className="font-size-xxl" style={cardDataCountStyle}>
                          {card.count}
                        </Box>
                        <Box>
                          <img
                            src={card.image}
                            height="50px"
                            width="50px"
                            style={{
                              backgroundColor: card.bgColor,
                              borderRadius: "5px",
                            }}
                          />
                        </Box>
                      </Stack>
                    </CardContent>
                  </Card>
                </DashboardTiles>
              )
          )}
        </Grid>

        <Grid container>
          <Tabs
            value={value}
            onChange={handleChange}
            indicatorColor="secondary"
            style={{
              backgroundColor: "#FFFF",
              height: "20px",
              justifyContent: "center",
              alignItems: "center",
              marginTop: "7px",
              marginLeft: "3px",
              boxShadow: "none",
            }}
          >
            {companyType === "NONE" ? (
              <Tab
                icon={<DealerIcon fill={value === 0 ? "#F2824C" : "#242424"} />}
                iconPosition="start"
                label={t("DASHBOARDTABDEALER")}
                style={{
                  borderRight: "1px solid #00000029",
                  width: "200px",
                  fontSize: "18px",
                  textTransform: "none",
                  color: value === 0 ? "#F2824C" : "#242424",
                }}
              />
            ) : (
              ""
            )}
            <Tab
              icon={
                <CustomersIcon fill={value === 1 ? "#F2824C" : "#242424"} />
              }
              iconPosition="start"
              label={t("DASHBOARDTABCUSTOMER")}
              style={{
                width: "200px",
                fontSize: "18px",
                textTransform: "none",
                color: value === 1 ? "#F2824C" : "#242424",
              }}
            />
          </Tabs>
        </Grid>

        {loading && (
          <Box sx={{ display: "flex" }} className="loader-container">
            <CircularProgress className="loader" />
          </Box>
        )}
        <Grid
          item
          style={{ width: "100%", height: 300 }}
        >
          {value === 0 && (
            <TabPanel value={value} index={value}>
              <DataTableLatest
                columns={columns}
                rows={accountRows}
                page={page}
                dashboardPanel={true}
                count={totalRecords}
                rowId={(row) => row.id}
                pageCount={totalPages}
                pageSize={rowsPerPage}
                handleChange={(newPage, size) => handlePage(newPage, size)}
              />
            </TabPanel>
          )}

          {value === 1 && (
            <TabPanel value={value} index={value}>
              <DataTableLatest
                columns={columns}
                rows={accountRows}
                page={page}
                dashboardPanel={true}
                count={totalRecords}
                rowId={(row) => row.id}
                pageCount={totalPages}
                pageSize={rowsPerPage}
                handleChange={(newPage, size) => handlePage(newPage, size)}
              />
            </TabPanel>
          )}
        </Grid>
      </Grid >
    </>
  );
}

export default DashBoardData;
